import PageWrapper from '../../components/PageWrapper'
import arrowIcon from '../../assets/icons/arrowIcons.png'
import DefaultButton from '../../components/Button/Button'
import EditProfileForm from '../../components/Settings/EditProfileForm'
import { useNavigate } from 'react-router-dom'

const EditProfile = () => {
  const navigate = useNavigate()

  return (
    <PageWrapper title="Settings" description="Password and Account settings">
      <div className="flex mb-10 gap-14 pl-2">
        <div className="flex gap-5 cursor-pointer" onClick={() => navigate('/settings')}>
          <img src={arrowIcon} alt="" />
          <DefaultButton
            buttonType="secondary"
            border="none"
            width="30px"
            fontSize="18px"
            fontWeight="500"
            marginRight="20px"
          >
            Settings
          </DefaultButton>
        </div>
        <DefaultButton fontSize="18px" fontWeight="500" padding="10px">
          Edit profile
        </DefaultButton>
      </div>
      <EditProfileForm />
    </PageWrapper>
  )
}

export default EditProfile
